// Unique Assignment Name
export const UNIQUE_ASSIGNMENT_NAME_REQUEST = 'UNIQUE_ASSIGNMENT_NAME_REQUEST';
export const UNIQUE_ASSIGNMENT_NAME_DONE = 'UNIQUE_ASSIGNMENT_NAME_DONE';
export const UNIQUE_ASSIGNMENT_NAME_FAILED = 'UNIQUE_ASSIGNMENT_NAME_FAILED';
export const UNIQUE_ASSIGNMENT_NAME_RESET = 'UNIQUE_ASSIGNMENT_NAME_RESET';